import React from 'react'
import { css } from '@emotion/react'
import { SUI } from 'shared/ui'
import Search from 'subapps/ticketing/components/TicketList/Header/Search'
import NewTicketButton from './NewTicketButton'

const searchContainerStyle = () => theme => css`
  display: flex;
  justify-content: space-between;
  background-color: ${theme.color.monochrome.white};
  padding-right: 8px;
  border-bottom: 1px solid ${theme.color.monochrome.medium};
`

const searchStyle = css`
  flex-grow: 1;
`

const newTicketButtonStyle = css`
  margin: 12px 0 12px 12px;
`

export default function SearchBar() {
  return (
    <SUI>
      <div css={searchContainerStyle}>
        <Search css={searchStyle} classicView />
        <NewTicketButton css={newTicketButtonStyle} />
      </div>
    </SUI>
  )
}
